/* eslint-disable no-restricted-globals */
import { ERROR_TYPES } from 'api/System/constants'
import CommonIcon from 'CommonIcon'
import parse from 'html-react-parser'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getMomentDate } from 'utils'

import { AnonymousWrapper, AppHeaderContainer } from '../index'
import useStyles from './useStyles'

const { INFORMATION } = ERROR_TYPES

interface Props {
  errorMessage: string
  errorTill: string
  errorType: ERROR_TYPES
  goToMainPage: () => void
}

function ErrorPage({ errorMessage, errorTill, errorType, goToMainPage }: Props) {
  const classes = useStyles()
  const { t: translate } = useTranslation()
  const reloadApp = () => {
    location.reload()
    location.replace('/')
  }

  const message = (errorMessage || '').startsWith('error.') ? translate(errorMessage || 'error.message') : errorMessage || ''
  const till = errorTill && getMomentDate(errorTill).format('L LT')

  return (
    <AnonymousWrapper>
      <AppHeaderContainer hideFetchTime variant="dark" />
      <CommonIcon className={classes.moon} name="moon" />
      <div className="anonymous-page_message">
        <h2>{parse(message)}</h2>
        {till && <h3>({`${translate('error.till')} ${till}`})</h3>}
        {errorType !== INFORMATION && <p>{translate('error.hint')}</p>}
      </div>

      <div className="anonymous-page_button">
        {errorType === INFORMATION && (
          <button type="button" onClick={goToMainPage}>
            {translate('error.ok')}
          </button>
        )}
        {errorType !== INFORMATION && (
          <button type="button" onClick={reloadApp}>
            {translate('error.reload')}
          </button>
        )}
      </div>
    </AnonymousWrapper>
  )
}

export default ErrorPage
